export default function init() {
  /* global Glider */
  if (typeof Glider !== "undefined") {
    new Glider(document.querySelector(".glider"), {
      slidesToShow: 2,
      itemWidth: 180,
      arrows: {
        prev: ".glider-prev",
        next: ".glider-next",
      },
      responsive: [
        {
          // screens greater than >= 768px
          breakpoint: 768,
          settings: {
            // Set to `auto` and provide item width to adjust to viewport
            slidesToShow: "auto",
            slidesToScroll: "auto",
            itemWidth: 350,
          },
        },
      ],
    })
  }
}
